/**
 * Gallery plate for vision images — frame, aspect ratio, subtle unifying overlay.
 * @see frontend/src/design/DESIGN.md (image plate pattern)
 */
import React from 'react';
import { EyeIcon } from '@heroicons/react/24/outline';
import { resolveMediaUrl } from '../../utils/mediaUrl';

const VisionImagePlate = ({ src, alt = '', className = '' }) => {
  const resolvedSrc = resolveMediaUrl(src);
  return (
  <div
    className={`relative aspect-[4/3] overflow-hidden rounded-lg border border-hairline bg-bone-raised m-1 ${className}`}
  >
    {resolvedSrc ? (
      <>
        <img
          src={resolvedSrc}
          alt={alt}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'linear-gradient(180deg, rgba(33,29,22,0.12) 0%, rgba(33,29,22,0.22) 100%)',
            mixBlendMode: 'multiply',
          }}
          aria-hidden
        />
        <div
          className="absolute inset-0 pointer-events-none opacity-[0.35]"
          style={{ backgroundColor: '#F3EFE6' }}
          aria-hidden
        />
      </>
    ) : (
      <div className="absolute inset-0 flex items-center justify-center bg-bone-raised">
        <EyeIcon className="w-10 h-10 text-ink-faint" />
      </div>
    )}
  </div>
  );
};

export default VisionImagePlate;
